import React from 'react'
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { SHOW_CLAIM_GROUP_TASKS } from '@rd-web-markets/market/dist/constants';
import ClaimGroupListClientsViewReportButton from './ClaimGroupListClientsViewReportButton';
import ClaimGroupsListClientCreateProjectButton from './ClaimGroupsListClientCreateProjectButton';
import { useSelector } from 'react-redux';

const iconStyles = {
  height: '1.2rem',
  width: '1.2rem',
  marginTop: '9px',
  fontWeight: 600
};

const ClaimGroupListClientsByCompany = ({claimGroups, loading, accountType}) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user)

  const renderTaskIconStatus = (status, categoryTitle) => {
    switch(status) {
      case 'not_started':
        return (
          <div className='claim-task-status-badge' data-testid={`icon-${categoryTitle}-badge-not_started`}>
            <span style={iconStyles} className="material-icons md-18">close</span>
          </div>
        )
      case 'in_progress':
        return (
          <div className='claim-task-status-badge'  data-testid={`icon-${categoryTitle}-badge-in_progress`}>
            <span className="material-icons md-18" style={iconStyles}>format_align_center</span>
          </div>
        )
      case 'completed':
        return (
          <div className='claim-task-status-badge' data-testid={`icon-${categoryTitle}-badge-success`}>
            <span className="material-icons md-18" style={iconStyles}>done</span>
          </div>
        )
      default:
        <></>
    }
  }

  const renderTasks = (claimGroup) => {
    return (
      claimGroup.tasks.map((task) => {
        return (
          <div className='me-4' key={task.category_title}>
            <div className='text-center'>
              {renderTaskIconStatus(task.status, task.category_title)}
            </div>
            <div className='mt-3'>
              <span>{t(task.category_title)}</span>
            </div>
          </div>
        );
      })
    )
  };

  const renderEmptyList = () => {
    return (
      <>
      </>
    )
  }

  const toLink = claimGroup => {
    const hasDashboardAccess = user.user_accesses?.find(
      uA => uA.rollable_id === claimGroup.id && uA.rollable_type === 'ClaimGroup'
    )?.dashboard_access

    if (!hasDashboardAccess) {
      return `/${accountType}/claim_groups/${claimGroup.id}/project_overview`
    }

    if (process.env.PUBLIC_URL !== '/be' && process.env.PUBLIC_URL !== '/de') {
      return (
        claimGroup.company.dashboard_type === 'business_unit_intensity_breakdown' ?
        `/${accountType}/claim_groups/${claimGroup.id}/regular_realtime_dashboard/${claimGroup.company.id}`
        :
        `/${accountType}/claim_groups/${claimGroup.id}/dashboard/${claimGroup.company.id}`
      )
    } else if(process.env.PUBLIC_URL === '/de') {
      return `/${accountType}/claim_groups/${claimGroup.id}/project_overview`
    } else {
      return `/${accountType}/claim_groups/${claimGroup.id}/claim_group_dashboard`
    }
  }

  return (
    <>
      {claimGroups.map((claimGroup) => (
        <Card className='claim-group-list-card p-4' >
          <h3 className='mb-3'>{claimGroup.name}</h3>
          <div className='d-flex flex-row justify-content-between'>
            {
              claimGroup.tasks.length && (
                SHOW_CLAIM_GROUP_TASKS ?
                  renderTasks(claimGroup)
                  :
                  renderEmptyList()
              )
            }
            <div className='projects-block ps-4'>
              <h3 className='text-center font-weight-bold'>{claimGroup.claim_project_reports_count}</h3>
              <div className='mt-4'>{t('projects')}</div>
            </div>
            <div>
              <h3 className='text-center font-weight-bold'>{claimGroup.in_progress_projects}</h3>
              <div className='mt-4'>{t('in_progress')}</div>
            </div>
            <div className='costs-block pe-4'>
              <h3 className='text-center font-weight-bold'>{claimGroup.cost_collected_projects}</h3>
              <div className='mt-4'>{t('cost_collected')}</div>
            </div>

            <div className="claim-group-buttons d-flex flex-column align-items-center">
              <ClaimGroupsListClientCreateProjectButton claimGroup={claimGroup} loading={loading} />
              <ClaimGroupListClientsViewReportButton claimGroup={claimGroup} loading={loading} accountType={accountType} />
              <Button
                size="md"
                as={Link}
                to={toLink(claimGroup)}
              >
                View Claim <span className="material-icons md-18">arrow_forward</span>
              </Button>
            </div>


          </div>
        </Card>
      ))}
    </>
  )
}

export default ClaimGroupListClientsByCompany
